// import dayjs from 'dayjs'

/* 时间过滤器 - 年月日-时分 */
// export const formatTime = (value, format = 'YYYY-MM-DD HH:mm:ss') => dayjs(value).format(format)
export const formatTime = (value, format = 'YYYY-MM-DD HH:mm:ss') => '暂未实现'

/* 金额：分转元 101 => [￥]1.01 */
export const formatPrice = (centPrice, withPreIcon = false, trim = false) => {
  const price = +centPrice ? (centPrice / 100).toFixed(2) : '0.00'
  return (withPreIcon ? '￥' : '') + (trim ? price.replace(/\.?0*$/, '') : price)
}
// 一位数前面补零 '2' => '02'
export const formatSingleNumberPreFix0 = (number) => {
  return parseInt(number) < 10 ? ('0' + number) : number
}
